import BaseCadastro from "components/BaseCadastro";
import { Column, ColumnEditorOptions } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import ItemPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/ItemPlanoAuditoria";
import { Dropdown } from "primereact/dropdown";
import { useSearchParams } from "react-router-dom";
import { useToastContext } from "components/alert/ToastContext";
import { Checkbox } from "primereact/checkbox";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { set, useForm } from "react-hook-form";
import { Label } from "components/input/Label";
import { AutoComplete } from "primereact/autocomplete";
import RequisitoAuditoria from "model/auditoria5s/requisitoAuditoria/RequisitoAuditoria";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { generateKey } from "utils/generateKey";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import ClassePlanoAuditoria from "model/auditoria5s/planoDeAuditoria/ClassePlanoAuditoria";
import PlanoAuditoriaService from "service/auditoria5s/PlanoAuditoriaService";

const planoAuditoriaService = new PlanoAuditoriaService();

export default function PlanoAuditoriaCadastro() {

    const titulo = "Cadastro de Plano de Auditoria";

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [planoAuditoria, setPlanoAuditoria] = useState<PlanoAuditoria>(new PlanoAuditoria());
    const [classeSelecionada, setClasseSelecionada] = useState<ClassePlanoAuditoria | null>(null);

    const [opcoesRequisito, setOpcoesRequisito] = useState<any[]>([]);
    const [opcoesRequisitoFiltradas, setOpcoesRequisitoFiltradas] = useState<any[]>([]);

    const [planos, setPlanos] = useState<PlanoAuditoria[]>([]);
    const [visibleDuplicarPlano, setVisibleDuplicarPlano] = useState(false);
    const [planoDuplicar, setPlanoDuplicar] = useState<PlanoAuditoria>(new PlanoAuditoria());

    useEffect(() => {
        planoAuditoriaService.consultarRequisitos().then((resposta) => {
            setOpcoesRequisito(resposta);
        }).catch((erro) => {
            console.log(erro);
        });

    }, []);

    useEffect(() => {
        if (visibleDuplicarPlano) {
            planoAuditoriaService.planos().then((resposta) => {
                setPlanos(resposta);
            }).catch((erro) => {
                console.log(erro);
            });
        }
    }, [visibleDuplicarPlano])

    function validar() {

        if (!planoAuditoria.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function validarPersonalizado() {
        let soma = 0;
        for (let i = 0; i < planoAuditoria.classes.length; i++) {
            if (planoAuditoria.classes[i].ativo) {
                soma += planoAuditoria.classes[i].nota_maxima;
            }
            if (!planoAuditoria.classes[i].itensPlanoAuditoria || planoAuditoria.classes[i].itensPlanoAuditoria.length < 1) {
                msgAlerta("Itens insuficientes", "Todas as classes devem ter itens");
                return false;
            }
            for (let j = 0; j < planoAuditoria.classes[i].itensPlanoAuditoria.length; j++) {
                if (planoAuditoria.classes[i].itensPlanoAuditoria[j].requisitoAuditoria.id < 1) {
                    msgAlerta("Requisito inválido", "Todos os itens devem ter requisito");
                    return false;
                }
            }
        }
        if (soma != 10) {
            msgAlerta("Soma inválida", "Soma das notas Máximas é diferente de 10");
            return false;
        }

        return true
    }

    const editorTextClasse = (options: ColumnEditorOptions) => {
        return (
            <InputText required value={options.rowData[options.field]} onChange={(e) => onChangeClasseVerificacao(options, e.target.value)} style={{ width: '100%' }} />
        )
    }

    const editorNumberClasse = (options: ColumnEditorOptions) => {
        return (
            <InputText required type="number" value={options.rowData[options.field]} onChange={(e) => onChangeClasseVerificacao(options, parseFloat(e.target.value))} style={{ width: '100%' }} />
        )
    }

    const requisitoEditor = (data: ColumnEditorOptions) => {
        return (
            <AutoComplete
                suggestions={opcoesRequisitoFiltradas}
                itemTemplate={(item) => item.classificacaoRequisito.nome + " - " + item.nome}
                style={{ width: '100%' }}
                inputStyle={{ width: '100%' }}
                dropdown
                field="nome"
                value={data.rowData["requisitoAuditoria"]}
                completeMethod={(e) => {
                    let requisitos = [];
                    for (let i = 0; i < opcoesRequisito.length; i++) {
                        let requisito = opcoesRequisito[i];
                        if (requisito.classificacaoRequisito.nome.toLowerCase().includes(e.query.toLowerCase())) {
                            requisitos.push(requisito);
                        } else if (requisito.nome.toLowerCase().includes(e.query.toLowerCase())) {
                            requisitos.push(requisito);
                        } else if ((requisito.classificacaoRequisito.nome + " - " + requisito.nome).toLowerCase().includes(e.query.toLowerCase())) {
                            requisitos.push(requisito);
                        }
                    }
                    setOpcoesRequisitoFiltradas(requisitos);
                }}
                onChange={(e) => {
                    if (typeof e.target.value === "string") {
                        let requisito = new RequisitoAuditoria();
                        requisito.nome = e.target.value;
                        onChangeItemClasseVerificacao(data, e.target.value)
                    } else if (typeof e.target.value === "object") {
                        onChangeItemClasseVerificacao(data, e.target.value)
                    }


                }}
            />
        )
    }

    const editorAtivo = (options: ColumnEditorOptions) => {
        return (
            <Checkbox checked={options.rowData[options.field]} onChange={(e) => onChangeItemClasseVerificacao(options, e.checked)} />
        )
    }

    const onChangeClasseVerificacao = (options: ColumnEditorOptions, value: any) => {
        options.rowData[options.field] = value;

        setarClasseNaVerificacao(options.rowData, options.rowIndex);
    }

    const setarClasseNaVerificacao = (classeAlterada: ClassePlanoAuditoria, index: number) => {
        planoAuditoria.classes[index] = classeAlterada;
        setPlanoAuditoria({ ...planoAuditoria })
    }

    const onChangeItemClasseVerificacao = (options: ColumnEditorOptions, value: any) => {
        if (classeSelecionada) {
            options.rowData[options.field] = value;
            let classeLocal = { ...classeSelecionada };
            classeLocal.itensPlanoAuditoria[options.rowIndex] = options.rowData;

            setClasseSelecionada(classeLocal);
            setPlanoAuditoria({ ...planoAuditoria })
        }
    }

    function duplicar(id: number) {
        planoAuditoriaService.consultar(id).then(resposta => {

            //retirando referencias do plano copiada
            let classes = resposta.classes.map(classe => {
                classe.key = generateKey();
                classe.id = 0;
                classe.planoAuditoria = new PlanoAuditoria();
                classe.itensPlanoAuditoria = classe.itensPlanoAuditoria.map(item => {
                    item.id = 0;
                    item.key = generateKey();
                    item.classePlanoAuditoria = new ClassePlanoAuditoria();
                    return item;
                });
                return classe;
            });
            setPlanoAuditoria({ ...planoAuditoria, classes: classes });
            setVisibleDuplicarPlano(false);
        }).catch(erro => {
            console.log(erro);
            setVisibleDuplicarPlano(false);
        })

    }

    return (

        <BaseCadastro
            model={planoAuditoria} service={planoAuditoriaService}
            setModel={(value: PlanoAuditoria) => setPlanoAuditoria(value)}
            validar={() => validar()}
            validarPersonalizado={() => validarPersonalizado()}
            urlService="/planoAuditoria"
            pathCadastro="/planoAuditoria"
            tituloPagina={'Plano de Auditoria'}
            onSave={(model: PlanoAuditoria) => {
                setClasseSelecionada(null)
            }}
            botoesExtra={<>
                <Button label="Duplicar" icon="pi pi-copy" style={{ marginLeft: 8 }} onClick={() => setVisibleDuplicarPlano(true)} />
            </>}
        >
            {visibleDuplicarPlano ?
                <Dialog header="Duplicar Plano" visible={visibleDuplicarPlano} style={{ width: '50vw' }} onHide={() => setVisibleDuplicarPlano(false)}
                    footer={<>
                        <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleDuplicarPlano(false)} />
                        <Button label="Duplicar" icon="pi pi-check" onClick={() => duplicar(planoDuplicar.id)} />
                    </>}
                >
                    <div className="row">
                        <label className="col col-sm-12">Selecione o plano que deseja duplicar</label>
                        <div className="col col-sm-12">
                            <Dropdown
                                style={{ width: '40%' }}
                                value={planoDuplicar}
                                options={planos}
                                optionLabel="nome"
                                onChange={(e) => {
                                    setPlanoDuplicar(e.value);
                                }}
                                placeholder="Selecione o plano"
                                filter
                                showClear
                            />
                        </div>
                    </div>
                </Dialog>
                : null}
            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={planoAuditoria.ativo}
                    onChange={(e) => { setPlanoAuditoria({ ...planoAuditoria, ativo: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Ativo?</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={planoAuditoria.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setPlanoAuditoria({ ...planoAuditoria, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">
                    <BaseDataTableEdit
                        selected={classeSelecionada}
                        setSelected={(value: ClassePlanoAuditoria) => setClasseSelecionada(value)}
                        isSelection
                        dataKey="key"
                        tituloLista="Classes"
                        lista={planoAuditoria.classes}
                        setLista={(value: ClassePlanoAuditoria[]) => {
                            setPlanoAuditoria({ ...planoAuditoria, classes: value })
                        }}
                        getNewModel={() => new ClassePlanoAuditoria()}
                        scrollHeight="300px"
                        scrollable={true}
                    >

                        <Column field="nome" header="Nome" editor={(options) => editorTextClasse(options)} />
                        <Column field="nota_maxima" header="Nota Máxima" editor={(options) => editorNumberClasse(options)} style={{ width: 300 }} />
                        <Column field="ativo" header="Ativo"
                            body={(rowData) => <Checkbox checked={rowData.ativo} onChange={(e) => {
                                rowData.ativo = e.checked;
                                setPlanoAuditoria({ ...planoAuditoria });
                            }} />}
                        />
                    </BaseDataTableEdit>
                </div>
            </div>
            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemPlanoAuditoria()}
                        dataKey="key"
                        lista={classeSelecionada?.itensPlanoAuditoria ? classeSelecionada.itensPlanoAuditoria : []}
                        setLista={(value: ItemPlanoAuditoria[]) => {
                            if (classeSelecionada) {
                                classeSelecionada.itensPlanoAuditoria = value;
                                setClasseSelecionada({ ...classeSelecionada });
                                planoAuditoria.classes[planoAuditoria.classes.findIndex((classe) => classe.key === classeSelecionada.key)] = classeSelecionada;
                                setPlanoAuditoria({ ...planoAuditoria });
                            }
                        }}
                        onRowReorder={(e) => {
                            e.value.forEach((item: any, index: number) => {
                                item.sequencial = index + 1;
                            });
                            if (classeSelecionada) {
                                classeSelecionada.itensPlanoAuditoria = e.value as ItemPlanoAuditoria[];
                                setClasseSelecionada({ ...classeSelecionada });
                            }

                        }}
                        reordable={true}
                        addButtonDisabled={!classeSelecionada}
                        scrollHeight="500px"
                        scrollable={true}
                    >
                        <Column rowReorder style={{ width: '3rem' }} />
                        <Column field="requisitoAuditoria.classificacaoRequisito.nome" header="Classificação" />
                        <Column field="requisitoAuditoria" header="Nome" body={(rowData) => rowData.requisitoAuditoria.nome} editor={(options) => requisitoEditor(options)} />
                        <Column field="requisitoAuditoria.descricao" header="Descrição" />
                        <Column field="ativo" header="Ativo"
                            body={(rowData) => <Checkbox checked={rowData.ativo} onChange={(e) => {
                                rowData.ativo = e.checked;
                                setPlanoAuditoria({ ...planoAuditoria });
                            }} />}
                            editor={editorAtivo} />
                    </BaseDataTableEdit>
                </div>

            </div>



        </BaseCadastro>
    )
}
